﻿import { Decorators } from "@serenity-is/corelib";

export enum EmailQueueStatus {
    Failed = -1,
    InQueue = 0,
    Sent = 1
}
Decorators.registerEnumType(EmailQueueStatus, 'Serenity.Pro.EmailQueue.EmailQueueStatus');